module.exports = __webpack_public_path__ + "static/media/abrindoValvula.23e3aa1a.jpg";